module.exports = __webpack_public_path__ + "img/month_back_color_icon.2ef9f07c.svg";